<template>
  <div class="page-wrapper">
    <main class="main">
      <div class="page-header">
        <div class="container">
          <h1 class="page-title mb-0" id="movetarget">
            {{ duoyuyan(service) }}
          </h1>
        </div>
      </div>
      <nav class="breadcrumb-nav mb-10 pb-8">
        <div class="container">
          <ul class="breadcrumb">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>
              {{ duoyuyan(service) }}
            </li>
          </ul>
        </div>
      </nav>
      <div class="page-content">
        <div class="container">
          <section class="title-section show-code-action">
            <h2 class="title">
              {{ duoyuyan(service) }}
            </h2>
            <p
              style="text-align: left"
              v-html="duoyuyan(service, 'miaoshu')"
            ></p>
          </section>

          <section
            class="element-section text-center mb-10 pb-2"
            v-if="leixings.length"
          >
            <el-divider></el-divider>
            <div
              class="row elements cols-xl-6 cols-lg-6 cols-md-5 cols-xs-4 cols-3"
            >
              <div
                class="mb-4"
                v-for="(item, index) in leixings"
                :key="index"
                @click.stop="select_leixing(item)"
              >
                <div
                  :style="{
                    background:
                      'url(' + item.tupian || $tupianmoren + ') no-repeat',
                    backgroundSize: 'cover',
                    width: '100%',
                    height: 0,
                    paddingTop: '100%',
                    boxShadow:
                      '0 2rem 3rem rgb(0 0 0 / 5%), 0 0 5px rgb(0 0 0 / 5%)',
                    borderRadius: '1rem',
                    cursor: 'pointer',
                    backgroundPositionX: 'center',
                    backgroundPositionY: 'center',
                    position: 'relative',
                  }"
                >
                  <p
                    class="hang-2"
                    style="
                      max-width: 60%;
                      position: absolute;
                      top: 10%;
                      left: 10%;
                      background: white;
                      color: #03a9f4;
                      border-radius: 3px;
                      padding: 2px 10px;
                      text-align: left;
                      box-shadow: 0 0 10px 2px rgba(151, 151, 151, 0.1);
                    "
                  >
                    {{ duoyuyan(item) }}
                  </p>
                  <div
                    v-if="leixing.id === item.id"
                    style="
                      position: absolute;
                      bottom: 10px;
                      right: 10px;
                      height: 30px;
                      line-height: 30px;
                      width: 30px;
                      background: #03a9f4;
                      color: white;
                      box-shadow: 0 0 8px 2 rgba(0, 0, 0, 0.2);
                      border-radius: 50%;
                    "
                  >
                    <i class="el-icon-circle-check" style="font-size: 30px"></i>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            class="element-section text-center mb-10 pb-2"
            v-if="wentis.length"
          >
            <el-divider></el-divider>
            <p
              class="text-default section-desc mx-auto mb-8 pointer"
              v-if="wentixuanze.length > 0"
              @click="reset_wenti"
            >
              <i class="w-icon-angle-left"></i>
              <span>
                {{
                  wentixuanze.length >= 1
                    ? wentixuanze[wentixuanze.length - 1].mingcheng
                    : ""
                }}
              </span>
            </p>
            <div
              class="row elements cols-xl-6 cols-lg-6 cols-md-5 cols-xs-4 cols-3 mb-8"
            >
              <div
                class="mb-4"
                v-for="(item, index) in wenti"
                :key="index"
                @click="select_wenti(item)"
              >
                <div class="tree-item">
                  <div
                    class="tree-item-main"
                    :style="{
                      backgroundImage: 'url(' + item.tupian + ')',
                    }"
                  >
                    <div
                      class="tree-item-main-mingcheng"
                      :style="{
                        background: item.tupian
                          ? 'transparents'
                          : 'rgb(3, 169, 244)',
                      }"
                    >
                      {{ duoyuyan(item) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-8">
              <ul
                class="breadcrumb"
                v-for="(item, index) in wentifinally"
                :key="index"
              >
                <li
                  style="
                    width: 100%;
                    text-align: left;
                    position: relative;
                    padding-right: 20px;
                    font-weight: bold;
                    font-size: 18px;
                  "
                >
                  {{ duoyuyan(item) }}
                  <span
                    v-if="item.jiage"
                    style="font-weight: 500; font-size: 14px; padding: 0 10px"
                  >
                    {{ (item.jiage / 100).toFixed(2) + $shezhi.huobi }}
                  </span>
                  <span
                    style="font-weight: 500; font-size: 14px; padding: 0 10px"
                    v-html="duoyuyan(item, 'miaoshu')"
                  >
                  </span>
                  <div class="delete" @click="wentifinally.splice(index, 1)">
                    <i class="w-icon-times-solid"></i>
                  </div>
                </li>
              </ul>
            </div>
            <span
              v-if="wentifinally.length > 0"
              @click="post_commande_service"
              class="btn btn-dark btn-outline btn-rounded ls-25 ml-4"
            >
              <div class="btn-text">
                <i class="w-icon-visit"></i>
              </div>
            </span>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { getFuWu, getFuWuLeiXing, getFuWuWenTi } from "@/api/fuwu";

export default {
  name: "FuWu",
  components: {},
  watch: {
    $route(to, from) {
      if (to.query.ukey != from.query.ukey) {
        this.ukey = to.query.ukey;
        this.get_service_http();
      }
    },
  },
  data() {
    return {
      ukey: "",
      service: {},
      leixings: [],
      leixing: {},
      wentis: [], // 后台返回的全部问题
      wenti: [], // 当前正在被选择的问题列表
      wentixuanze: [], // 当前已选的问题层级
      wentifinally: [],
      loading: false,
    };
  },
  mounted() {
    this.ukey = this.$route.query.ukey;
    localStorage.setItem("fuwugongsi", this.$route.query.gongsi);
    this.get_service_http();
  },
  methods: {
    get_service_http() {
      this.loading = true;
      getFuWu({ ukey: this.ukey })
        .then((data) => {
          if (data.status === "SUCCESSED") {
            this.service = data.data;
            this.leixings = [];
            this.wentis = [];
            if (this.service.leixing === 1)
              this.get_wenti_http(this.service.ukey);
            else this.get_leixing_http();
          }
        })
        .finally(() => (this.loading = false));
    },
    get_leixing_http() {
      this.loading = false;
      getFuWuLeiXing({ fuwu: this.service.ukey })
        .then((data) => {
          if (data.status === "SUCCESSED") this.leixings = data.data;
        })
        .finally(() => (this.loading = false));
    },
    select_leixing(item) {
      if (this.leixing.id === item.id) return;
      this.leixing = JSON.parse(JSON.stringify(item));
      this.toast_success({
        title: "",
      });
      if (this.service.leixing === 3) this.get_wenti_http(this.leixing.ukey);
      else if (this.wentis.length === 0) this.get_wenti_http(this.ukey);
    },
    get_wenti_http(ukey) {
      this.loading = true;
      getFuWuWenTi({ fuwuleixing: ukey })
        .then((data) => {
          if (data.status === "SUCCESSED") {
            this.wentis = data.data;
            this.wenti = data.data;
          }
        })
        .finally(() => (this.loading = false));
    },
    select_wenti(item) {
      if (item.children && item.children.length > 0) {
        this.wenti = item.children;
        this.wentixuanze.push(item);
        return;
      }
      if (!this.wentifinally.some((v) => v.id === item.id)) {
        this.wentifinally.push(item);
        this.toast_success({ title: "" });
      }
      this.wenti = this.wentis;
      this.wentixuanze = [];
    },
    reset_wenti() {
      this.wenti =
        this.wentixuanze.length === 1
          ? this.wentis
          : this.wentixuanze[this.wentixuanze.length - 2].children;
      this.wentixuanze.splice(this.wentixuanze.length - 1, 1);
    },
    post_commande_service() {
      localStorage.setItem("service", JSON.stringify(this.service));
      localStorage.setItem("leixing", JSON.stringify(this.leixing));
      localStorage.setItem("wenti", JSON.stringify(this.wentifinally));
      this.$router.push("/servicecommande");
    },
  },
};
</script>

<style scoped>
.tree-item {
  width: 100%;
  padding-top: 100%;
  box-shadow: 0 2rem 3rem rgb(0 0 0 / 5%), 0 0 5px rgb(0 0 0 / 5%);
  border-radius: 2rem;
  cursor: pointer;
  position: relative;
}

.tree-item-main {
  position: absolute;
  border-radius: 2rem;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-position: center;
  background-size: cover;
}

.tree-item-main-mingcheng {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  font-size: 20px;
  color: white;
  font-weight: bold;
  border-radius: 2rem;
  height: 100%;
}

.delete {
  position: absolute;
  right: 0;
  top: 2px;
  height: 13px;
  width: 13px;
}

.delete > i {
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s;
  cursor: pointer;
}

.delete > i:hover {
  transform: rotate(90deg);
}

.btn-text {
  position: relative;
  display: inline-block;
  width: auto;
}

.xuanzhuan {
  position: absolute;
  top: 8px;
  left: 0;
  animation: anixuanzhuan 0.8s infinite linear;
}

@keyframes anixuanzhuan {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
